import { Component, Prop, Emit, Watch, Vue } from "vue-property-decorator";
import { Action, Getter, State, Mutation } from "vuex-class";
import Header from "@/components/header/header";
import AsideCart from "@/components/asideCart/asideCart";

import Footer from "@/components/footer/footer";
import commerceBanner from "@/components/commerceBanner/commerceBanner";
import category from "@/components/commerceCategory/commerceCategory";
import SkeletonList from "@/components/skeletonList/skeletonList";
import SkeletonFluid from "@/components/skeletonFluid/skeletonFluid";
import ProductsBtn from "@/components/productsBtn/productsBtn";
import SupportBtn from "@/components/supportBtn/supportBtn";
import Alert from "@/components/alert/alert";
import SuperCategoriesScrollMenu from "@/components/superCategoriesScrollMenu/superCategoriesScrollMenu";
import ModalOkCancel from "@/components/modalOkCancel/modalOkCancel";

import SuperCategories from "@/components/superCategories/superCategories";
import { cityParser } from "@/plugins/city_parser";

@Component({
  components: {
    Header,
    AsideCart,
    Footer,
    category,
    commerceBanner,
    SkeletonList,
    SkeletonFluid,
    ProductsBtn,
    SuperCategories,
    Alert,
    SuperCategoriesScrollMenu,
    ModalOkCancel,
    SupportBtn
  },
  beforeRouteLeave(to: any, from: any, next: any) {
    if (
      to.name !== "checkout" &&
      to.name !== "product" &&
      to.name !== "principal" &&
      this.getCartTemporal.length !== 0
    ) {
      this.isShowCartClear = true;
      this.next = next;
    } else {
      next();
    }
  }
})
export default class LayoutProducts extends Vue {
  @Action action_getCity: any;
  @Action action_getCategories: any;
  @Getter getUniversity: any;
  @Getter getCartTemporal: any;
  @Getter getCountry: any;
  @Getter getCity: any;
  @Getter getCategories: any;
  @Getter getIsUnderMobile: any;
  @Getter getIsLoadingCategories: any;
  @Getter getUser: any;
  @Getter getIsToken: any;
  @Getter getIsXLScreen: any;
  @Getter getOpenCart: any;
  @Getter getOpenCategories;
  @Getter getOpenSearchBar;
  @Getter getCurrentSuperCategory;
  @Getter getCurrentCategory;
  @Getter getCurrentProducts;
  @Getter getCartDeletedProducts;

  @Mutation CART_TEMPORAL: any;
  @Mutation IS_SELECT_COUNTRY;
  @Mutation CURRENT_SUPER_CATEGORY: any;
  @Mutation IS_LOADING_CATEGORIES: any;
  @Mutation OPEN_CART: any;
  @Mutation OPEN_CATEGORIES;
  @Mutation OPEN_SEARCH_BAR;
  @Mutation CART_DELETED_PRODUCTS;

  next = () => {};

  /* Supercategoríes */
  superCategories = [];
  superCategoryId = 1;

  deleteProductsText = "";
  showDeletedProductsModal = false;


  isRecentsView = false;

  async mounted() {
    this.setCityParam();
    this._getSuperCategories();
    this.setPageTitle();
  }

  setPageTitle() {
    if (window && window.document && window.document.title && this.getCity.commercial_name) {
      window.document.title = `Comida congelada ${this.getCity.commercial_name} - TodosComemos`;
    }
  }

  setCityParam() {
    const cityParam = this.$route.params.city_id;
    const storeCity = cityParser(this.getCity.commercial_name);
    if((cityParam && cityParam !== storeCity) || (!cityParam)) {
      this.$router.replace({ params: {
        city_id: storeCity
      }});
    }
  }

  _getSuperCategories() {
    let categories =
      this.getCity &&
      this.getCity.super_categories &&
      this.getCity.super_categories.sort((a, b) => a.ordinal - b.ordinal);

    if (categories) {
      this.superCategories = categories.filter((item) => item.is_active);
    } else {
      this.superCategories = [];
    }
  }

  _goToRecents() {
    this.$router.push({
      name: "root"
    });
  }


  get getHeader() {
    if (this.$route.name) {
      const name = this.$route.name;
      return name !== "checkout";
    }
    return false;
  }

  get showScrollBar() {
    const name = this.$route.name;
    if (name && name.length) {
      return name !== "search" && name !== "productDetail";
    }
  }

  get showProductsButton() {
    const name = this.$route.name;
    if (name) {
      return name !== "productDetail";
    }
  }

  get getGeneralOverlay() {
    let response = false;
    response = this.getOpenCart;
    return response;
  }

  get getProductsOverlay() {
    let response = false;
    response = this.getOpenCategories || this.getOpenSearchBar;
    return response;
  }

  _closeOverlay() {
    this.OPEN_CATEGORIES(false);
    this.OPEN_SEARCH_BAR(false);
  }

  closeCart() {
    this.OPEN_CART(false);
  }

  _onBreadcrumb(position: number) {
    const routeName = this.$route.name;
    let count = 0;
    if(routeName === 'productDetail') {
      count = 3;
    } else if(routeName === 'commerceCategory') {
      count = 2;
    } else if(routeName === 'superCategories') {
      count = 1;
    } else {
      count = position;
    }
    if(!this.getCurrentCategory) {
      count--;
    }
    count = (position - count);
    this.$router.go(count);
  }

  get showBreadcrumb() {
    let response = true;
    const routeName = this.$route.name;
    if(routeName === 'search' || routeName === 'featuredProducts') {
      response = false;
    }
    return response;
  }

  @Watch('getCartDeletedProducts', { deep: true })
  onCartDeletedProductsChange() {
    if (this.getCartDeletedProducts.length > 0) {
      const deletedProducts = [...this.getCartDeletedProducts];
      let deletedProductsString =
        "Algunos de los productos en tu carrito" +
        " ya <strong>no se encuentran disponibles:</strong><br><br>";
      for (let i = 0; i < deletedProducts.length; i++) {
        if (i === deletedProducts.length - 1) {
          deletedProductsString += "- " + deletedProducts[i];
        } else {
          deletedProductsString += "- " + deletedProducts[i] + "<br>";
        }
      }
      this.deleteProductsText = deletedProductsString;
      this.showDeletedProductsModal = true;
      this.CART_DELETED_PRODUCTS([]);
    }
  }

  onDeleteProductsAccept() {
    this.showDeletedProductsModal = false;
    this.deleteProductsText = "";
    this.$router.go(0);
  }
}
